{
  "BOM": 65279,
  "TAB": 9,
  "LINE_FEED": 10,
  "CARRIAGE_RETURN": 13,
  "SPACE": 32,
  "EXCLAMATION": 33,
  "DOUBLE_QUOTE": 34,
  "SHARP": 35,
  "PERCENT": 37,
  "AMPERSAND": 38,
  "SINGLE_QUOTE": 39,
  "ASTERISK": 42,
  "PLUS": 43,
  "COMMA": 44,
  "MINUS": 45,
  "DOT": 46,
  "COLON": 58,
  "SMALLER_THAN": 60,
  "GREATER_THAN": 62,
  "QUESTION": 63,
  "COMMERCIAL_AT": 64,
  "LEFT_SQUARE_BRACKET": 91,
  "BACKSLASH": 92,
  "RIGHT_SQUARE_BRACKET": 93,
  "GRAVE_ACCENT": 96,
  "LEFT_CURLY_BRACKET": 123,
  "VERTICAL_LINE": 124,
  "RIGHT_CURLY_BRACKET": 125
}
